import { CustomColumn } from '../../../types/customColumn';
import { formatCurrency, formatQuantity } from '../../../utils/formatCurrency';

export const taxCreditProductColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },

  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => {
      const { productCode, productName, categoryName } = row.original;
      return (
        <div className="text-sm leading-6">
          {/* Código del producto */}
          <div className="font-mono text-gray-500 dark:text-gray-400 text-xs">
            {productCode ? `(${productCode})` : '—'}
          </div>
          {/* Nombre */}
          <div className="font-medium text-black dark:text-white">
            {productName}
          </div>
          {/* Categoría (misma caja/clases, ahora en dos líneas) */}
          <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
            <div>
              <strong>CATEGORÍA:</strong>
            </div>
            <div>{categoryName || '—'}</div>
          </div>
        </div>
      );
    },
  },
  
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unitCode, settledQuantity } = row.original;

      return (
        <div className="text-sm leading-6">
          <div>
            {formatQuantity(quantity)} {unitCode || ''}
          </div>

          {settledQuantity !== undefined && (
            <div className="text-gray-500 mt-1 text-xs">
              <strong>Asentado:</strong> {formatQuantity(settledQuantity)}{' '}
              {unitCode || ''}
            </div>
          )}
        </div>
      );
    },
  },

  {
    Header: 'Costo Unitario',
    accessor: 'unitCost',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${formatQuantity(value)}</div>
    ),
  },
  {
    Header: 'IVA Total',
    accessor: 'ivaTotal',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${formatCurrency(value)}</div>
    ),
  },
  {
    Header: 'Total Costo',
    accessor: 'totalCost',
    customCell: ({ value }) => (
      <div className="text-sm font-medium leading-6">
        ${formatCurrency(value)}
      </div>
    ),
  },
];
